var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCricket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 58,
    fill: "none",
    viewBox: "0 0 59 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M41.3122 17.8064C43.0922 19.5865 43.0977 22.4709 41.3244 24.2577L23.1852 42.5352C23.0247 42.341 22.8536 42.1527 22.6719 41.971C19.5527 38.8518 14.4774 38.8518 11.3582 41.971C8.239 45.0902 8.239 50.1655 11.3582 53.2847L4.4311 46.3576C2.45998 44.3865 2.45998 41.1907 4.4311 39.2195L30.2636 13.387C32.0942 11.5564 35.0622 11.5564 36.8928 13.387L44.3837 5.8961C45.6021 4.67766 47.5846 4.67766 48.8031 5.8961C50.0215 7.11453 50.0215 9.09708 48.8031 10.3155L41.3122 17.8064ZM11.9374 53.8103L11.9106 53.8371L11.3582 53.2847C11.5445 53.471 11.7379 53.6463 11.9374 53.8103Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.7725 51.8705C10.4331 49.5311 10.4331 45.7246 12.7725 43.3852C15.1119 41.0458 18.9184 41.0458 21.2578 43.3852C23.5972 45.7246 23.5972 49.5311 21.2578 51.8705C18.9184 54.2099 15.1119 54.2099 12.7725 51.8705Z",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCricket);
export default __webpack_public_path__ + "static/media/cricket.6379a1d534cb8de9a43285c696fe0924.svg";
export { ForwardRef as ReactComponent };